import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { defineMessages, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import FormikContainer from "../../../../components/form/FormikContainer.jsx";
import genericTranslations from "../../../../utils/genericTranslations.js";
import {
  createMalfunctionCategory,
  fetchMalfunctionsCategories,
} from "../../thunks.js";

import MalfunctionsForm from "./MalfunctionsForm";

const messages = defineMessages({
  malfunction: {
    id: "modules.Malfunctions.components.MalfunctionDetail.malfunction",
    description: "Malfunction label.",
    defaultMessage: "Malfunction workorder",
  },
});

const MalfunctionsDetail = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { identifier } = useParams();

  const [error, setError] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchMalfunctionsCategories());
      } catch (err) {
        setError(err);
      }
    };
    fetchData();
  }, [dispatch]);

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    const body = {
      failureCode: values.category,
      vehicleNumber: identifier,
      vehicleType: "TRAIN",
      description: values.comment,
    };

    let response;
    try {
      response = await dispatch(createMalfunctionCategory(body));
    } catch (err) {
      setError(`Er ging iets fout bij het opslaan: ${err}`);
    } finally {
      setSubmitting(false);
    }

    if (response.ResultData) {
      navigate("/malfunctions/malfunctions-confirmation", { replace: true });
    }
  };

  const validate = (values) => {
    const errors = {};
    const required = ["category"];

    required.forEach((field) => {
      if (!values[field]) errors[field] = "Verplicht";
    });
    return errors;
  };

  if (error) {
    return (
      <strong>{intl.formatMessage(genericTranslations.errorMessage)} </strong>
    );
  }

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {intl.formatMessage(messages.malfunction)}{" "}
        {intl.formatMessage(genericTranslations.add).toLowerCase()}
      </Card.Header>
      <Card.Body>
        <FormikContainer
          initialValues={{}}
          onSubmit={handleSubmit}
          validate={validate}
          formComponent={MalfunctionsForm}
        />
      </Card.Body>
    </Card>
  );
};

export default MalfunctionsDetail;
